// extracted by mini-css-extract-plugin
module.exports = {"relatedPosts":"RelatedBlogs_relatedPosts__sImid","title":"RelatedBlogs_title___7BYq"};